import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChannelsandoperationsService } from '../../../../services/channelsandoperations.service';
import { TiposSakesService } from '../../../../services/tipos_sakes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-editar-tipo-sake',
  templateUrl: './editar-tipo-sake.component.html',
  styleUrls: ['./editar-tipo-sake.component.scss'],
})
export class EditarTipoSakeComponent implements OnInit {
  form = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(15),
        Validators.pattern(/^[a-zA-Z_-\s]*$/),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  constructor(
    public dialogRef: MatDialogRef<EditarTipoSakeComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public canalService: ChannelsandoperationsService,
    public tiposSakesService: TiposSakesService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form.controls.nombre.setValue(this.data.nombre);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onSubmit() {
    this.form.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    );
    this.form.value.id_tipos_sakes = this.data.id_tipos_sakes;
    this.form.value.borrado = 0;
    this.tiposSakesService.actualizar(this.form.value).subscribe((data) => {
      //console.log(data);
      this.openSnackBar('Tipo Operación actualizado con éxito', 'X');
      this.dialogRef.close();
    });
  }
}
